import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const reportsApi = createApi({
  reducerPath: "reportsApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: [],
  endpoints: (builder) => ({
    getDashboardStats: builder.query({
      query: () => ({
        url: "/reports/stats",
        method: "GET",
      }),
    }),
    inventoryFlow: builder.query({
      query: (days = 7) => ({
        url: "/reports/inventory-flow",
        method: "GET",
        params: { days },
      }),
    }),
    getCentralStockReport: builder.query({
      query: ({ filter } = {}) => ({
        url: "/reports/centralstock",
        method: "GET",
        params: filter ? { filter } : {},
      }),
    }),
    getBranchStockReport: builder.query({
      query: ({ filter } = {}) => ({
        url: "/reports/branchstock",
        method: "GET",
        params: filter ? { filter } : {},
      }),
    }),
    getCategoryReport: builder.query({
      query: ({ filter } = {}) => ({
        url: "/reports/category",
        method: "GET",
        params: filter ? { filter } : {},
      }),
    }),
    getIssuedReport: builder.query({
      query: ({ filter } = {}) => ({
        url: "/reports/issued",
        method: "GET",
        params: filter ? { filter } : {},
      }),
    }),
    getPendingRequestsReport: builder.query({
      query: ({ filter } = {}) => ({
        url: "/reports/pendingrequests",
        method: "GET",
        params: filter ? { filter } : {},
      }),
    }),
    getLowStockReport: builder.query({
      query: ({ filter } = {}) => ({
        url: "/reports/lowstock",
        method: "GET",
        params: filter ? { filter } : {},
      }),
    }),
    getItemEntryReport: builder.query({
      query: ({ filter } = {}) => ({
        url: "/reports/itementry",
        method: "GET",
        params: filter ? { filter } : {},
      }),
    }),
  }),
});

export const {
  useGetDashboardStatsQuery,
  useInventoryFlowQuery,
  useGetCentralStockReportQuery,
  useGetBranchStockReportQuery,
  useGetCategoryReportQuery,
  useGetIssuedReportQuery,
  useGetPendingRequestsReportQuery,
  useGetLowStockReportQuery,
  useGetItemEntryReportQuery,
} = reportsApi;
